var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87868 1.37868C6.44129 0.81607 7.20435 0.5 8 0.5C8.79565 0.5 9.55871 0.81607 10.1213 1.37868C10.6839 1.94129 11 2.70435 11 3.5C11 3.77614 10.7761 4 10.5 4C10.2239 4 10 3.77614 10 3.5C10 2.96957 9.78929 2.46086 9.41421 2.08579C9.03914 1.71071 8.53043 1.5 8 1.5C7.46957 1.5 6.96086 1.71071 6.58579 2.08579C6.21071 2.46086 6 2.96957 6 3.5V6.5C6 6.77614 5.77614 7 5.5 7C5.22386 7 5 6.77614 5 6.5V3.5C5 2.70435 5.31607 1.94129 5.87868 1.37868Z",
    fill: "#205493"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 7C3.94772 7 3.5 7.44772 3.5 8V13.5C3.5 14.0523 3.94772 14.5 4.5 14.5H11.5C12.0523 14.5 12.5 14.0523 12.5 13.5V8C12.5 7.44772 12.0523 7 11.5 7H4.5ZM2.5 8C2.5 6.89543 3.39543 6 4.5 6H11.5C12.6046 6 13.5 6.89543 13.5 8V13.5C13.5 14.6046 12.6046 15.5 11.5 15.5H4.5C3.39543 15.5 2.5 14.6046 2.5 13.5V8Z",
    fill: "#205493"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.c76547e0964729370c8fe9219e34d486.svg";
export { ForwardRef as ReactComponent };